import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { Box, Typography } from "@mui/material";

const data = [
  {
    name: "Age 15-20",
    percentage: 20,
  },
  {
    name: "Age 21-25",
    percentage: 55,
  },
  {
    name: "Age 26-30",
    percentage: 15,
  },
  {
    name: "Age 31-35",
    percentage: 5,
  },
  {
    name: "Age 35-40",
    percentage: 3,
  },
  {
    name: "Age 50+",
    percentage: 2,
  },
];

const ContentEngagementBarGraph = () => {
  return (
    <Box
      sx={{
        border: "1px solid lightgrey",
        padding: "10px",
        borderRadius: "10px",
      }}
      textAlign={"center"}
      width={"100%"}
    >
      <Typography textAlign={"center"} variant="p" width={"100%"} gutterBottom>
        Age
      </Typography>
      <ResponsiveContainer width={500} height={400}>
        <BarChart
          data={data}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="name"
            angle={-45}
            textAnchor="end"
            height={100}
            interval={0}
            style={{ fontSize: "12px" }}
          />
          <YAxis tickFormatter={(tick) => `${tick}%`} />
          <Tooltip formatter={(value) => `${value}%`} />
          <Legend />
          <Bar dataKey="percentage" fill="#82ca9d" />
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default ContentEngagementBarGraph;
